import { z } from "zod";
import { makeGetRequest } from "../../utils";

type GetCloudRecordingUsageReportOptions = {
	from: string;
	to: string;
};
const CloudRecordingStorageSchema = z.object({
	date: z.string(),
	usage: z.string(),
	plan_usage: z.string(),
	free_usage: z.string(),
});

const GetCloudRecordingUsageReportResponseSchema = z
	.object({
		from: z.string(),
		to: z.string(),
		cloud_recording_storage: z.array(CloudRecordingStorageSchema),
	})
	.deepPartial();

type GetCloudRecordingUsageReportResponse = z.infer<
	typeof GetCloudRecordingUsageReportResponseSchema
>;
const getCloudRecordingUsageReport = async (
	token: string,
	options: GetCloudRecordingUsageReportOptions,
): Promise<GetCloudRecordingUsageReportResponse> => {
	const res = await makeGetRequest({
		token,
		pathList: ["v2", "videosdk", "report", "cloud-recording"],
		options,
	});
	return GetCloudRecordingUsageReportResponseSchema.parse(res);
};

export const curriedGetCloudRecordingUsageReport = (token: string) => (
	options: GetCloudRecordingUsageReportOptions,
) => getCloudRecordingUsageReport(token, options);